export default __webpack_public_path__ + "static/media/img10.09941142.png";